var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 13.8489 7.68379",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6644 1.09357L7.3698 7.49601C7.31134 7.55554 7.24192 7.60276 7.1655 7.63498C7.08909 7.6672 7.00718 7.68379 6.92446 7.68379C6.84174 7.68379 6.75983 7.6672 6.68341 7.63498C6.60699 7.60276 6.53757 7.55554 6.47911 7.49601L0.184468 1.09357C0.0663552 0.973437 0 0.810498 0 0.6406C0 0.470702 0.0663552 0.307763 0.184468 0.187627C0.302581 0.0674912 0.462777 0 0.629814 0C0.796851 0 0.957047 0.0674912 1.07516 0.187627L6.92446 6.13789L12.7738 0.187627C12.8322 0.128142 12.9017 0.0809556 12.9781 0.0487625C13.0545 0.0165693 13.1364 0 13.2191 0C13.3018 0 13.3837 0.0165693 13.4601 0.0487625C13.5365 0.0809556 13.606 0.128142 13.6644 0.187627C13.7229 0.247112 13.7693 0.317732 13.801 0.395453C13.8326 0.473174 13.8489 0.556475 13.8489 0.6406C13.8489 0.724725 13.8326 0.808026 13.801 0.885747C13.7693 0.963468 13.7229 1.03409 13.6644 1.09357Z",
    fill: "var(--fill-0, black)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.6143335bcd41bd7c3f6256b7f3141abe.svg";
export { ForwardRef as ReactComponent };